(function () {
  const TRIGGER_VARIANT_ID = 56238697775430;
  const GIFT_VARIANT_ID = 56396048924998;
  const PROMO_TAG = 'gift-promo';

  const CART_CHANGE_ENDPOINTS = [
    '/cart/add',
    '/cart/change',
    '/cart/update',
    '/cart/clear'
  ];

  const rawFetch = window.fetch.bind(window);
  let isSyncing = false;
  let syncPromise = null;
  let syncTimer = null;
  let skipFetchListener = false;
  const pendingCartRequests = new Set();

  function cartUrl(path) {
    const root = theme?.routes?.root_url || '/';
    return `${root}${path.replace(/^\//, '')}`;
  }

  function isCartChangeRequest(resource) {
    const url = typeof resource === 'string' ? resource : resource?.url;
    if (!url) return false;

    try {
      const parsedUrl = new URL(url, window.location.origin);
      return CART_CHANGE_ENDPOINTS.some((endpoint) => parsedUrl.pathname.includes(endpoint));
    } catch (error) {
      return CART_CHANGE_ENDPOINTS.some((endpoint) => url.includes(endpoint));
    }
  }

  function getSectionsToRender() {
    const sections = [];
    const miniCart = document.getElementById('mini-cart');
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (miniCart) sections.push('mini-cart');
    if (mainCartItems?.dataset.id) sections.push(mainCartItems.dataset.id);
    if (mainCartFooter?.dataset.id) sections.push(mainCartFooter.dataset.id);
    if (document.getElementById('cart-icon-bubble')) sections.push('cart-icon-bubble');
    if (document.getElementById('mobile-cart-icon-bubble')) sections.push('mobile-cart-icon-bubble');
    if (document.getElementById('cart-live-region-text')) sections.push('cart-live-region-text');

    return [...new Set(sections.filter(Boolean))];
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  function renderCartSections(cart) {
    if (!cart?.sections) return;

    const miniCart = document.getElementById('mini-cart');
    if (miniCart && cart.sections['mini-cart']) {
      miniCart.innerHTML = getSectionInnerHTML(cart.sections['mini-cart'], '.shopify-section');
    }

    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartItemsSection = mainCartItems?.dataset.id;
    if (mainCartItems && mainCartItemsSection && cart.sections[mainCartItemsSection]) {
      const contents = mainCartItems.querySelector('.js-contents') || mainCartItems;
      contents.innerHTML = getSectionInnerHTML(cart.sections[mainCartItemsSection], '.js-contents');
    }

    const mainCartFooter = document.getElementById('main-cart-footer');
    const mainCartFooterSection = mainCartFooter?.dataset.id;
    if (mainCartFooter && mainCartFooterSection && cart.sections[mainCartFooterSection]) {
      const footer = mainCartFooter.querySelector('.cart__footer') || mainCartFooter;
      footer.innerHTML = getSectionInnerHTML(cart.sections[mainCartFooterSection], '.cart__footer');
    }

    ['cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-live-region-text'].forEach((sectionId) => {
      const element = document.getElementById(sectionId);
      if (element && cart.sections[sectionId]) {
        element.innerHTML = getSectionInnerHTML(cart.sections[sectionId], '.shopify-section');
      }
    });
  }

  function getTaggedTriggerQty(cart) {
    const cartContainers = [
      document.getElementById('main-cart-items'),
      document.getElementById('mini-cart')
    ].filter(Boolean);

    const cartLines = cartContainers.flatMap((container) => {
      return [...container.querySelectorAll('[data-variant-id]')];
    });

    if (!cartLines.length) return null;

    const taggedLines = document.querySelectorAll(
      `[data-gift-trigger-variant-id="${TRIGGER_VARIANT_ID}"][data-gift-promo-tag="${PROMO_TAG}"]`
    );

    if (!taggedLines.length) return 0;

    return [...taggedLines].reduce((total, line) => {
      const input = line.querySelector('[name="updates[]"]');
      const quantity = parseInt(input?.value || line.dataset.quantity || '0', 10);
      return total + (Number.isNaN(quantity) ? 0 : quantity);
    }, 0);
  }

  function getGiftInventoryLimitFromLine(giftLine) {
    if (!giftLine) return null;

    const isAvailable = giftLine.dataset.giftVariantAvailable === 'true';
    const inventoryPolicy = giftLine.dataset.giftVariantInventoryPolicy;
    const inventoryManagement = giftLine.dataset.giftVariantInventoryManagement;

    if (!isAvailable) return 0;
    if (!inventoryManagement || inventoryPolicy === 'continue') return null;

    const quantity = parseInt(giftLine.dataset.giftVariantInventoryQuantity || '0', 10);
    return Number.isNaN(quantity) ? 0 : Math.max(quantity, 0);
  }

  function getGiftInventoryLimit() {
    return getGiftInventoryLimitFromLine(document.querySelector(`[data-gift-variant-id="${GIFT_VARIANT_ID}"]`));
  }

  function getGiftInventoryLimitFromSections(cart) {
    if (!cart?.sections) return null;

    for (const html of Object.values(cart.sections)) {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const giftLine = documentFragment.querySelector(`[data-gift-variant-id="${GIFT_VARIANT_ID}"]`);
      if (giftLine) return getGiftInventoryLimitFromLine(giftLine);
    }

    return null;
  }

  function getGiftTargetQty(triggerQty, inventoryLimit = getGiftInventoryLimit()) {
    if (inventoryLimit === null) return triggerQty;

    return inventoryLimit >= triggerQty ? triggerQty : 0;
  }

  async function fetchCart() {
    const response = await rawFetch(cartUrl('/cart.js'), {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error('Impossibile leggere il carrello');
    return response.json();
  }

  async function addGift(quantity) {
    const response = await rawFetch(cartUrl('/cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity
      })
    });

    if (!response.ok) throw new Error('Impossibile aggiungere il prodotto omaggio');
    return response.json();
  }

  async function updateGiftLines(giftItems, triggerQty, renderSections) {
    const updates = {};
    giftItems.forEach((item, index) => {
      updates[item.key] = index === 0 ? triggerQty : 0;
    });

    const body = {
      updates,
      sections_url: window.location.pathname
    };

    const sections = getSectionsToRender();
    if (renderSections && sections.length) body.sections = sections;

    const response = await rawFetch(cartUrl('/cart/update.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) throw new Error('Impossibile aggiornare il prodotto omaggio');
    return response.json();
  }

  async function syncGift(options = {}) {
    if (isSyncing && syncPromise) return syncPromise;

    isSyncing = true;
    skipFetchListener = true;

    syncPromise = (async () => {
      try {
        const cart = await fetchCart();
        const taggedTriggerQty = getTaggedTriggerQty(cart);
        const triggerQty = taggedTriggerQty ?? cart.items
          .filter((item) => item.variant_id === TRIGGER_VARIANT_ID)
          .reduce((total, item) => total + item.quantity, 0);
        let targetGiftQty = getGiftTargetQty(triggerQty);
        const giftItems = cart.items.filter((item) => item.variant_id === GIFT_VARIANT_ID);
        const giftQty = giftItems.reduce((total, item) => total + item.quantity, 0);

        if (targetGiftQty === giftQty && giftItems.length <= 1) return { updated: false, cart };

        let updatedCart;
        if (giftItems.length === 0 && targetGiftQty > 0) {
          await addGift(targetGiftQty);
          const addedGiftItems = (await fetchCart()).items.filter((item) => item.variant_id === GIFT_VARIANT_ID);
          updatedCart = await updateGiftLines(addedGiftItems, targetGiftQty, true);

          const renderedInventoryLimit = getGiftInventoryLimitFromSections(updatedCart);
          const renderedTargetGiftQty = getGiftTargetQty(triggerQty, renderedInventoryLimit);

          if (renderedTargetGiftQty !== targetGiftQty) {
            targetGiftQty = renderedTargetGiftQty;
            updatedCart = await updateGiftLines(addedGiftItems, targetGiftQty, options.renderSections);
          }
        } else if (giftItems.length === 0) {
          return { updated: false, cart };
        } else {
          updatedCart = await updateGiftLines(giftItems, targetGiftQty, options.renderSections);
        }

        if (options.render !== false) {
          renderCartSections(updatedCart);
          document.dispatchEvent(new CustomEvent('gift:updated', { detail: { cart: updatedCart } }));
        }

        return { updated: true, cart: updatedCart };
      } catch (error) {
        console.error('Errore sync omaggio:', error);
        throw error;
      } finally {
        skipFetchListener = false;
        isSyncing = false;
        syncPromise = null;
      }
    })();

    return syncPromise;
  }

  function queueSync(delay = 350, options = {}) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(() => {
      syncGift(options).catch(() => {});
    }, delay);
  }

  function wait(milliseconds) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, milliseconds);
    });
  }

  async function waitForPendingCartRequests() {
    if (!pendingCartRequests.size) return;
    await Promise.allSettled([...pendingCartRequests]);
  }

  async function finalCheckoutSync() {
    // Quantity inputs in this theme update the cart through a 300ms debounce.
    await wait(450);
    await waitForPendingCartRequests();
    await syncGift({ renderSections: false });
  }

  function syncedCartResponse(originalResponse, cart) {
    const headers = new Headers(originalResponse.headers);
    headers.set('Content-Type', 'application/json; charset=utf-8');

    return new Response(JSON.stringify(cart), {
      status: originalResponse.status,
      statusText: originalResponse.statusText,
      headers
    });
  }

  window.fetch = async function (...args) {
    const shouldWatchRequest = !skipFetchListener && isCartChangeRequest(args[0]);
    const request = rawFetch(...args);

    if (shouldWatchRequest) {
      pendingCartRequests.add(request);
    }

    let response;
    try {
      response = await request;
    } finally {
      if (shouldWatchRequest) {
        pendingCartRequests.delete(request);
      }
    }

    if (shouldWatchRequest && response.ok) {
      try {
        const syncResult = await syncGift({ renderSections: true, render: false });
        if (syncResult.updated && syncResult.cart?.sections) {
          return syncedCartResponse(response, syncResult.cart);
        }
      } catch (error) {
        console.error('Errore sync omaggio:', error);
      }
    }

    return response;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('action') !== theme?.routes?.cart_url) return;

    const submitter = event.submitter || document.activeElement;
    if (submitter?.getAttribute('name') !== 'checkout') return;

    event.preventDefault();
    try {
      await finalCheckoutSync();
    } finally {
      window.location.href = cartUrl('/checkout');
    }
  }, true);

  document.addEventListener('click', async (event) => {
    const checkoutLink = event.target.closest('a[href*="/checkout"]');
    if (!checkoutLink) return;

    event.preventDefault();
    try {
      await finalCheckoutSync();
    } finally {
      window.location.href = cartUrl('/checkout');
    }
  }, true);

  document.addEventListener('cart:updated', () => {
    queueSync(150, { renderSections: true });
  });

  document.addEventListener('cartdrawer:opened', () => {
    queueSync(150, { renderSections: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => queueSync(250, { renderSections: true }));
  } else {
    queueSync(250, { renderSections: true });
  }
})();
